import React, { useState ,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types';
import { fetchApp } from '../store/actions/appAction'
import Menubar from '../components/Menubar';
import Whatsapp from '../components/otp/Whatsapp'
import Sms from '../components/otp/Sms'
import { Typography, Grid, Divider, Switch, TextField, Button, Accordion, AccordionSummary, AccordionDetails, Box,Tabs, Tab, AppBar, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import OTPIntegration from '../components/instructions/OTPIntegration'
import clsx from 'clsx';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  containerOtpLogin : {
    paddingTop: "7%",
    paddingLeft: "22%",
    backgroundColor: "#e8e8e8",
    paddingRight: "7%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "5%",
      paddingRight: "5%"
    },
  },
  contentOtpLogin: {
    background: '#fff',
    padding: '2rem 2.4rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridAccordionOtpLogin: {
    background: '#fff',
    padding: '2rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },

  contentSocialLogin : {
    paddingTop: "7%",
    paddingLeft: "20%",
    backgroundColor: "#e8e8e8",
    paddingRight: "5%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "0",
      paddingRight: "0"
    },
  },
  layoutMainCreateApp: {
    background: "white",
    padding: "2rem 2rem",
    borderRadius: "10px",
    [theme.breakpoints.up("sm")]: {
      width: "80%",
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  gridSidebarSocialLogin : {
    padding: "0 2rem 0 1rem"
  },
  small : {
    marginRight: "10px"
  },
  gridAppSocialLogin: {
    background: '#fff',
    padding: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridUrlSocialLogin: {
    background: '#fff',
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridAccordionSocialLogin: {
    background: '#fff',
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },
  gridAPISocialLogin : {
    background: '#fff',
    marginLeft: "1rem",
    marginBottom: "3rem",
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
            <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}


const OtpApp = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const {id} = useParams()

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])

    const app = useSelector(state => state.appReducer.app)

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
      <React.Fragment>
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.containerOtpLogin}>
          <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom>
              {app.appName}
          </Typography>
          <br/>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.contentOtpLogin}> 
            <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>API Key</p>
            <TextField
              variant="outlined"
              margin="dense"
              fullWidth
              id="apiKey"
              name="apiKey"
              value={app.apiKey || ''}
              autoFocus
              className="text-grey"
              />
            </Grid>
          </Grid>
          <br/>

          <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom className="mb-20">
            One Time Password (OTP) Login
          </Typography>
          <Grid container>
            <Grid item xs={12} md={3} className={classes.gridSidebarSocialLogin}>
              <AppBar position="static" className="sidebarSocialLogin" style={{background: '#fff'}}>
                <Tabs value={value} onChange={handleChange} orientation="vertical">
                  <Tab className="text-darkgrey" label="Whatsapp" icon={<Avatar className={classes.small} alt="google logo" src="/icon-whatsapp.png" />} {...a11yProps(0)} />
                  {/* <Tab className="text-darkgrey" label="Sms" icon={<Avatar className={classes.small} alt="fb logo" src="/icon-sms.png" />} {...a11yProps(1)} /> */}
                </Tabs>
              </AppBar>
            </Grid>
            <Grid item xs={12} md={9}>
              <Grid item xs={12} md={12} className={classes.gridAppSocialLogin}>
                <TabPanel value={value} index={0}>
                  <Whatsapp />
                </TabPanel>
                {/* <TabPanel value={value} index={1}>
                  <Sms />
                </TabPanel> */}
              </Grid>
              <Grid item xs={12} md={12} className={classes.gridAccordionSocialLogin}>
                <OTPIntegration/>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider/>
    </React.Fragment>
  )
}

export default OtpApp
